import { render, staticRenderFns } from "./CuadraturaOrdenesServicioPantalla.vue?vue&type=template&id=1939a213&"
import script from "./CuadraturaOrdenesServicioPantalla.vue?vue&type=script&lang=ts&"
export * from "./CuadraturaOrdenesServicioPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports